<template>
  <div class="avatar" :style="'width:' + width + 'rem; height: ' + height + 'rem; background-image: url('+ url + '), url(/img/favicon.png); border-radius: ' + radius + 'px'">
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    radius: {
      type: Number,
      default: 100
    },
    width: {
      type: Number,
      default: 2.5
    },
    height: {
      type: Number,
      default: 2.5
    }
  }
}
</script>

<style src="./avatar.scss" lang="scss"></style>
